import script from "./MyCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCollection.vue?vue&type=script&setup=true&lang=js"

import "./MyCollection.vue?vue&type=style&index=0&id=2a4982e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a4982e6"]])

export default __exports__